module.exports = __webpack_public_path__ + "img/7.220971c.jpg";